/**
 * 260928 — job nền (author prompt, script-passes, dialogue, breakdown, continuity, durations…) trả 202 rồi
 * KẾT THÚC im lặng: không có response nào báo "xong" để reload theo. Bug thật: sau khi "Dựng prompt" chạy
 * xong, thẻ event vẫn "CHƯA CÓ PROMPT" và nút Generate khoá tới khi F5 — `authorPrompts()` chỉ
 * `setTimeout(reload, 2000)` MỘT LẦN, mà job author thật chạy lâu hơn vài giây nên lượt reload đó luôn rơi
 * vào lúc job CHƯA xong.
 *
 * Cách vá: `EventPlanTab` poll `getPlanJobs` mỗi 5-20s (đã có, cho băng "đang chạy ở nền") — hàm THUẦN dưới
 * đây so danh sách job giữa hai lượt poll: job có ở lượt TRƯỚC mà mất ở lượt NÀY là vừa xong (done hoặc
 * failed) ⇒ caller tự `reload()` dữ liệu plan. Không import antd/React ⇒ unit-test được dưới jest của
 * react-scripts (xem CLAUDE.md).
 */
export function jobsFinishedSincePoll(prevIds: Set<string> | null, nextJobs: { id: string }[]): boolean {
    if (!prevIds) return false; // lượt đầu (mount) — chưa có gì để so, đừng reload thừa.
    const nextIds = new Set(nextJobs.map((j) => j.id));
    return Array.from(prevIds).some((id) => !nextIds.has(id));
}
